







import {
  Component,
  Prop,
  Vue,
  Watch
} from "@/shared/vuepack";
import AddMfa from "@/employee/components/onboarding/AddMfa.vue";
import TermsModal from "@/employee/components/onboarding/TermsModal.vue";
import { useLoginPromptOrchestratorStore } from "@/employee/store/LoginPromptOrchestrator";
import { useMfaStore } from "@/shared/store/mfa";

@Component({
  components: {
    AddMfa,
    TermsModal
  }
})
export default class LoginPromptOrchestrator extends Vue {
  loginPromptOrchestratorStore = useLoginPromptOrchestratorStore();
  mfaStore = useMfaStore();

  @Watch("mfaStore.showMfaModal")
  onShowMfaModalChanged () {
    this.loginPromptOrchestratorStore.calculateShowMFAPrompt();
    this.loginPromptOrchestratorStore.showNextPrompt();
  }

  mounted () {
    this.loginPromptOrchestratorStore.loadRequiredData();
  }

  get showTerms () {
    return this.loginPromptOrchestratorStore.showTermsPrompt;
  }

  get showMfa () {
    return this.loginPromptOrchestratorStore.showMfaPrompt;
  }
}
